export const ADMISION = [{
    body: {
        paddingTop: 35,
        paddingBottom: 50,
        paddingHorizontal: 25,
    },
    body2: {
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 10,
        paddingRight: 10,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    section2: {
        position:"relative",
        width: "100%",
        height: "100%",
        border: "1px solid #000"
    },
    row: {
        flexDirection: 'row'
    },

    logo: {
        height: 50,
        width:"auto",
        marginLeft: 0,
    },

    logoPq: {
        height: 25,
        width: 25,
        marginLeft: 0,
    },

    logoQr: {
        height: 50,
        width:50,
        marginLeft: 0,
    },

    colContent40: {
        paddingHorizontal: 10,
        width: "20%"
    },
    colContent60: {
        paddingHorizontal: 10,
        width: "80%"
    },

    header1Left: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'left',
    },
    header1Right: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: 'right',
    },

    Negrita: {
        fontSize: 12,
        fontWeight: "bold"
    },
    Italica: {
        fontStyle: "italic"
    },
    textPeq: {
        fontSize: 8,
        marginBottom: 5,
        textAlign: 'left',
    },

    custonMt10: {
        marginTop: 10,
    },
    custonMt20: {
        marginTop: 20,
    },
    custonMt30: {
        marginTop: 30,
    },

    titulo: {
        backgroundColor: "#CCC"
    },
    customMl: {
        paddingHorizontal: 10,
    },

    bordeConstancia: {
        border: 0.8,
        borderRadius: 4,
        padding: 5,
    },
    font6: {
        fontSize: 6,
    },
    font7: {
        fontSize: 7,
    },
    font8: {
        fontSize: 8,
    },
    font9: {
        fontSize: 9,
    },
    font10: {
        fontSize: 10,
    },
    font12: {
        fontSize: 12,
    },
    font14: {
        fontSize: 14,
    },
    font16: {
        fontSize: 16,
    },
    center: {
        textAlign: 'center',
    },
    justify: {
        textAlign: 'justify',
    },
    right: {
        textAlign: 'right',
    },

    col1: {
        width: "25%",
    },
    col2: {
        width: "33%",
    },
    col3: {
        width: "50%",
    },
    col4: {
        width: "67%",
    },
    col5: {
        width: "75%",
    },
    col6: {
        width: "100%",
    },
    col7: {
        width: 20,
    },
    col8: {
        width: 520,
    },
    col9: {
        width: 480,
    },
    col10: {
        width: 70,
    },
    col11: {
        width: 30,
    },
    col12: {
        marginTop: 2,
        width: 520,
    },

    colTablaList1: {
        width: 290,
        borderColor: "#000"
    },
    colTablaList2: {
        width: 125,
        borderColor: "#000"
    },
    colTablaList3: {
        width: 70,
        borderColor: "#000"
    },
    colTablaList4: {
        width: 90,
        borderColor: "#000"
    },
    colTablaList5: {
        width: 380,
        borderColor: "#000"
    },

    colTablaCuenta1: {
        width: 45,
        borderColor: "#000"
    },
    colTablaCuenta2: {
        width: 70,
        borderColor: "#000"
    },
    colTablaCuenta3: {
        width: 185,
        borderColor: "#000"
    },
    colTablaCuenta4: {
        width: 80,
        borderColor: "#000"
    },
    colTablaCuenta5: {
        width: 205,
        borderColor: "#000"
    },
    colTablaCuenta6: {
        width: 130,
        borderColor: "#000"
    },

    colTablaInsc1: {
        width: 60,
        borderColor: "#000"
    },
    colTablaInsc2: {
        width: 210,
        borderColor: "#000"
    },
    colTablaInsc3: {
        width: 80,
        borderColor: "#000"
    },
    colTablaInsc4: {
        width: 110,
        borderColor: "#000"
    },
    colTablaInsc5: {
        width: 30,
        borderColor: "#000"
    },
    colTablaInsc6: {
        width: 110,
        borderColor: "#000"
    },
    colTablaInsc7: {
        width: 200,
        borderColor: "#000"
    },
    colTablaInsc8: {
        width: 270,
        borderColor: "#000"
    },
    colTablaInsc9: {
        width: 340,
        borderColor: "#000"
    },

    colTablaIngr1: {
        width: 170,
        borderColor: "#000"
    },
    colTablaIngr1_1: {
        width: 180,
        borderColor: "#000"
    },
    colTablaIngr2: {
        width: 70,
        borderColor: "#000"
    },
    colTablaIngr2_1: {
        width: 120,
        borderColor: "#000"
    },
    colTablaIngr3: {
        width: 200,
        borderColor: "#000"
    },
    colTablaIngr3_1: {
        width: 140,
        borderColor: "#000"
    },
    colTablaIngr4: {
        width: 510,
        borderColor: "#000"
    },


    colTabla1: {
        width: 200,
        borderColor: "#000"
    },
    colTabla2: {
        width: 60,
        borderColor: "#000"
    },
    colTabla3: {
        width: 80,
        borderColor: "#000"
    },
    colTabla4: {
        width: 40,
        borderColor: "#000"
    },
    colTabla3_c: {
        width: 90,
        borderColor: "#000"
    },
    colTabla4_c: {
        width: 30,
        borderColor: "#000"
    },
    colTabla5: {
        width: 420,
        borderColor: "#000"
    },

    colTabla6: {
        width: 20,
        borderColor: "#000"
    },
    colTabla7: {
        width: 440,
        borderColor: "#000"
    },
    colTabla7_c: {
        width: 420,
        borderColor: "#000"
    },
    colTabla8: {
        width: 80,
        borderColor: "#000"
    },
    colTabla9: {
        width: 460,
        borderColor: "#000"
    },
    colTabla8_c: {
        width: 100,
        borderColor: "#000"
    },
    colTabla9_c: {
        width: 440,
        borderColor: "#000"
    },
    colTabla10: {
        width: 540,
        borderColor: "#000"
    },

    colTablaRec1: {
        width: 100,
        borderColor: "#000"
    },
    colTablaRec2: {
        width: 80,
        borderColor: "#000"
    },
    colTablaRec3: {
        width: 272,
        borderColor: "#000"
    },
    colTablaRec4: {
        width: 100,
        borderColor: "#000"
    },
    colTablaRec5: {
        width: 180,
        borderColor: "#000"
    },
    colTablaRec6: {
        width: 272,
        borderColor: "#000"
    },
    bordeCol7:{
        padding: 3,
        /* borderTop: 0.5,
        borderBottom: 0.5,
        borderLeft: 0.8, */
    },

    borderTop: {
        borderTop: 0.5
    },

    bordeCol8:{
        padding: 3,
        /* borderBottom: 0.5,
        borderLeft: 0.5,
        borderRight: 0.5 */
    },

    bordeCol9:{
        padding: 3,
        borderBottom: 0.5,
        borderRight: 0.5,
    },

    bordeCol10:{
        padding: 3,
        borderTop: 0.5,
        borderBottom: 0.5,
        borderLeft: 0.8,
    },
    bordeCol11:{
        padding: 3,
        borderBottom: 0.5,
        borderLeft: 0.5,
        borderRight: 0.5
    },
    bordeCol12:{
        padding: 3,
        borderBottom: 1,
        borderRight: 0.5,
    },

    footer: {
        fontSize: 7,
        top: 710,
        position: 'absolute',
        textAlign: 'center',
    },

    footer2: {
        fontSize: 7,
        top: 680,
        position: 'absolute',
        textAlign: 'center',
    },

    footer3: {
        fontSize: 7,
        textAlign: 'center',
    },

    encabezado: {
        fontSize: 7,
        marginBottom: 5,
        marginLeft: 45,
        textAlign: 'center',
    },
    encabezado2: {
        fontSize: 7,
        marginBottom: 5,
        textAlign: 'center',
    },

    encabezado3: {
        fontSize: 7,
        marginBottom: 5,
        textAlign: 'left',
    },

    linea: {
        width:560,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 27,
        marginBottom: 5,
    },
    linea2: {
        width:460,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 27,
        marginBottom: 5,
    },
    linea3: {
        width:510,
        borderBottomColor: "#000",
        borderBottom: 0.5,
        marginLeft: 27,
        marginBottom: 5,
    },
    token: {
        position: "absolute",
        top: 0,
        left: 435,
        color: "#c60000",
        fontSize: 16,
        textAlign: "right"
    },
    tipo: {
        top: 0,
        color: "#c60000",
        fontSize: 12,
    }
}];


// WEBPACK FOOTER //
// ./src/components/Reportes/Styles/StylesAdmision.jsx